import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Loader from "../pages/Loader/Loader";
import { getOthersInfo } from "../redux/action/others/other";

const Section_BecomePartner = ({ data }) => {
    const dispatch = useDispatch()
    const { detail } = useSelector((state) => state.others)
    useEffect(() => {
        dispatch(getOthersInfo('belion'))
    }, [dispatch]);


    return (
        <>
            {!detail ? (
                <Loader />
            ) : (
                <>
                    {detail?.is_active &&
                        <section class="button-section-down" >
                            <div class="section-button">
                                <div class="about-partner-with">
                                    <a href="">{detail?.description1 ? detail?.description1 : 'Partner with us'}</a>
                                </div>
                                <div class="btn-about-down">
                                    <Link to="/sponsors/partner-with-us" class="btn__more">{detail?.button ? detail?.button : `Partner with us`}</Link>
                                </div>
                            </div>
                        </section>
                    }
                </>
            )}
        </>

    );
};

export default Section_BecomePartner;
